import api from '@/axios';

/**
 * 获取 用户信息详情"
 * @export
 * @returns
 */
 export function getUserinfo(params) {
  return api.getMockdata('/user/auth/userinfo', params);
};

/**
 * 获取 查询我的权益"
 * @export
 * @returns
 */
 export function queryMyEquity(params) {
  return api.getMockdata('/user/store/equity/queryMyEquity', params);
};

/**
 * 保存语言到cookie
 * @export
 * @returns
 */
 export function saveLocaleLanguageCode(params) {
  return api.postMockdata('/user/languageCode/open/saveLocale', params);
};

/**
 * 获取 “语言列表"
 * @export
 * @returns
 */
export function queryEnabledLanguageCode(params) {
  return api.getMockdata('/user/languageCode/open/queryEnabled', params);
};

/**
 * 获取 “我的应用"
 * @export
 * @returns
 */
export function queryClientByUserId(params) {
  return api.getMockdata('/user/v1/manager/client/queryClientByUserId', params);
};

/**
 * 单点登录其他系统
 * @export
 * @returns
 */
export function getRedirectUrl(params) {
  return api.postMockdata('/user/v1/manager/sso/getRedirectUrl', params);
};